import { render, staticRenderFns } from "./EntregaAnexoDownload.vue?vue&type=template&id=be84e814"
import script from "./EntregaAnexoDownload.vue?vue&type=script&lang=js"
export * from "./EntregaAnexoDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports